import React from 'react';
import { TEN } from 'appConstants';
import { useDispatch } from 'react-redux';
import { getThreadsWithUnreadMessages, fetchUnclaimedChats } from 'redux/actions';

export const useInitializeUserInboxes = (user) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    user.inboxAccessList.forEach((inbox) => {
      const { accountType: inboxType, userName: username, accountName } = inbox;
      dispatch(
        getThreadsWithUnreadMessages({
          inboxType,
          username,
          accountName,
          inboxAccessList: user.inboxAccessList,
          itemsPerPage: TEN,
        }),
      );
      dispatch(
        fetchUnclaimedChats({
          filters: [{ fieldName: 'assignedUserName', type: 'NotExists', value: true }],
        }),
      );
    });
  }, [user.inboxAccessList, dispatch]);
};
